module.exports = __webpack_public_path__ + "img/lightning-02.58c1d903.svg";